export * from "./text-input";
import TextInput from "./text-input";
export default TextInput;
